var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var ProductInfo = function(el) {
  this.$el = $(el);

  // Toggle more info 
  this.$el.on('click', '.more', function(){
    var $this = $(this);
    var $content = $this.next('.content-area');
    if($this.hasClass('open')) {
      $this.removeClass('open');
      $content.slideUp();
    } else {
      $this.addClass('open');
      $content.slideDown();
    }
  });

};

module.exports = ProductInfo;